/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ShareStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.99967 8.42241V1.35574M10.333 3.64862L8.36214 1.57108C8.23526 1.43908 8.17183 1.37308 8.09868 1.34835C8.03433 1.32659 7.96502 1.32659 7.90067 1.34835C7.82752 1.37308 7.76408 1.43908 7.63721 1.57108L5.66634 3.64862M10.333 5.33203C10.9534 5.33203 11.2636 5.33203 11.5147 5.4136C12.0221 5.57847 12.4199 5.97627 12.5848 6.48367C12.6663 6.73472 12.6663 7.04494 12.6663 7.66536V11.332C12.6663 12.2655 12.6663 12.7322 12.4847 13.0887C12.3249 13.4023 12.0699 13.6573 11.7563 13.817C11.3998 13.9987 10.9331 13.9987 9.99967 13.9987H5.99967C5.06625 13.9987 4.59954 13.9987 4.24302 13.817C3.92942 13.6573 3.67445 13.4023 3.51466 13.0887C3.33301 12.7322 3.33301 12.2655 3.33301 11.332V7.66536C3.33301 7.04494 3.33301 6.73472 3.41458 6.48367C3.57944 5.97627 3.97725 5.57847 4.48465 5.4136C4.7357 5.33203 5.04591 5.33203 5.66634 5.33203" strokeLinecap="round"/>
      </svg>
    </Icon>
  );
});

export { ShareStrokeIcon };
